import { Avatar, type Theme } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import { useTenantLogo } from "shared-ui/src/shared-features/my-acccounts/hooks/useTenantLogo";
import { TENANT_ID_UNDEFINED } from "@features/impersonation-feature/constants";
import useGetTenantLogo from "@features/impersonation-feature/hooks/useGetTenantLogo";

function getResponsiveAvatarSx(size: number) {
  const mobileSize = Math.max(size - 0.5, 0);

  return (theme: Theme) => ({
    width: theme.spacing(mobileSize),
    height: theme.spacing(mobileSize),
    flexShrink: 0,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(size),
      height: theme.spacing(size),
    },
  });
}

function getResponsiveIconSx(size: number) {
  const mobileSize = Math.max(size - 0.5, 0);

  return (theme: Theme) => ({
    fontSize: theme.spacing(mobileSize * 0.5625),
    color: "text.secondary",
    [theme.breakpoints.up("sm")]: {
      fontSize: theme.spacing(size * 0.5625),
    },
  });
}

export default function TenantAvatar({
  id,
  size = 4,
}: {
  id?: string;
  size?: number;
}) {
  const tenant = useTenantLogo({
    id: id === TENANT_ID_UNDEFINED ? undefined : id,
    useGetLogo: useGetTenantLogo,
  });
  if (tenant?.logoUrl) {
    return (
      <Avatar
        src={tenant.logoUrl}
        sx={[
          getResponsiveAvatarSx(size),
          {
            bgcolor: "action.selected",
            "& img": {
              objectFit: "contain",
              objectPosition: "center",
            },
          },
        ]}
      />
    );
  }
  return (
    <Avatar sx={[getResponsiveAvatarSx(size), { bgcolor: "action.selected" }]}>
      <BusinessIcon sx={getResponsiveIconSx(size)} />
    </Avatar>
  );
}
